// extracted by mini-css-extract-plugin
export default {"ratingBar":"LDIS_","ratingProgress":"qKPxB","ratingsLabels":"ZpsiA","ratingsLabelMid":"GHAyt","ratingsLabelMax":"IHWfv"};